import React, { useEffect } from "react";
import {Redirect, Route, Switch } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import Layout from './layout';
import ReturningPayfee from './sections/returningPayfee';
import LinkBankAccount from '../linkBankAccount/linkBankAccount';
import { InactiveDetection } from "../../../services/inactiveDetection";
import LayoutPREQUALFIT from '../../../components/flow/prequalFit/layout';
import Offer from "./sections/offer";
import PDFTerms from "../global-elements/PDFTerms";
 
function Router() {

  const resultStep = useStoreState(state => state.displayResult);
  const setting = useStoreState(state => state.siteSettingsModel);
  const termsStep = useStoreState(state => state.displayPrequalTerms);

  InactiveDetection.setInactiveTitle(null);
  useEffect(() => {
      document.querySelector("title").textContent = `${setting.brandSettings.ProductName || ""} - Mastercard`;
      InactiveDetection.setTitle(`${setting.brandSettings.ProductName} - Mastercard`);
  },[setting]);

  return (
    <>
        <Switch>
          <Route path="/getTerms/:productCode" component={() => <PDFTerms />} exact />
          <Route path="/payfee" component={() => <ReturningPayfee />} exact />
          <Route path="/link-account" component={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={"/" + window.location.search} /> } exact />
          <Route path="/offer" render={() => <Offer />} exact />
          <Route path="/:MainPath/termsOffer" component={() => (termsStep) ? <LayoutPREQUALFIT />  : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
          <Route  component={() => <Layout />}  />
        </Switch>
    </>
    
  );
}

export default Router;
